Vue.component('chat-footer', {
  props: ["options", "labellang"],
  template: '<transition v-if="isActive" name="bounce" enter-active-class="bounceInDown" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">' +
    '<div id="chat-footer" class="row no-gutters">' +
    '<div v-if="isComposing.agent" class="text-center composing"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>' +
    '<div class="col-xs-9 col-sm-9 col-md-9 col-lg-10 no-gutters" rel="tooltip" data-placement="top" :title="text.toolTipOnlyIe"  @mouseleave="hideTooltip()" >' +
    '<div rel="tooltipChar" data-placement="top" :title="labellang.maxAllowedCharsExceeded + options.internal.maxAllowedMessageSize"></div>'+
    '<input type="text" v-if="hasEmoticons" id="emojionearea" class="input-msg" :placeholder="checkCompatibiltyPlaceHolderForEmoticons()">' + // input with emoji 
    '<input type="text" v-else class="input-msg" :disabled="disabled" v-model.trim="newMessage" debounce="200" @keyup.enter="addMessage" :maxlength="getMaxAllowSize()" @keypress="checkValidInput" :placeholder="this.labellang.chatuserinputPlaceholder">' +
    '</div>' +
    '<div class="col-xs-3 col-sm-3 col-md-3 col-lg-2 list-icon no-gutters offset-top-10">' +
    '<button id="bt-send" v-if="hasEmoticons" :disabled="disabled" @click="addMessageWithEmoji" rel="tooltip" :title="text.send"><i class="material-icons">&#xE163;</i></button>' +
    '<button id="bt-send" v-else :disabled="disabled" @click="addMessage" rel="tooltip" :title="text.send"><i class="material-icons">&#xE163;</i></button>' +
    '<button @click="openReserveEmail" id="reserveEmail" v-if="options.configuration.allowEmailReservation" rel="tooltip" :title="text.email" data-toggle="button">' +
    '<i class="material-icons">&#xE0BE;</i>' +
    '</button>' +
    //'<button @click="openShareDoc" :disabled="disabled" id="docSharing"  v-bind:class="hasMmargin"  v-if="options.configuration.allowShareDoc"  rel="tooltip" :title="text.shareDoc"><i class="material-icons">&#xE226;</i></button>' +
    '</div>' +
    '</div>' +
    '</transition>',
  data: function() {
    return {
      isActive: false,
      newMessage: '',
      hasEmoticons: true,
      isComposing: {
        agent: false,
        customer: false
      },
      text: {
        send: this.labellang.send,
        shareDoc: this.labellang.tooltipShareDoc,
        email: this.labellang.emailToReserveTooltip,
        toolTipOnlyIe: '',

      },
      disabled: false,
      timerIsComposing: null,
      isTextInputDisable:false,

    }
  },
  computed: {
    hasMmargin: function () {
      return {
        setmargin: this.options.internal.isConvy
      }
    }
  },
  created: function() {
    var that = this;
    this.checkChannel();
    this.$parent.$on('onShowInput', function(val) {
      that.contentShow(val);
      if (val == true) {
        that.checkEmoji();
      }
    });

    bus.$on("onResumeChat", function(val) {
      that.disable(val);
    });

    bus.$on("onInputMsgDisabled", function(val) {
      that.disable(val);
      that.setInputDisable(val)
    });

    bus.$on("onInputClean", function() {
      that.setInputClean();
    });


    this.$parent.$on('onDisableFooter', function(boolean) {
      that.disable(boolean);
    });

    this.$parent.$on('onTrasfering', function() {
      that.disable(true);
    });

    this.$parent.$on('onTrasferEnd', function() {
      that.disable(false);
    });
    this.$parent.$on('onDocEnable', function() {
      that.showActionTooltipDoc();
    });
    this.$parent.$on('onPause', function(msg) {
      that.disable(true);
    })
    this.$parent.$on('onResume', function(msg) {
      that.disable(false);
    })
    this.$parent.$on('onComposingAgent', function(boolean) {
      that.composingAgent(boolean);
    });
    this.callTooltip();

  },
  methods: {
    composingAgent: function(boolean) {
      this.isComposing.agent = boolean;
    },
    checkEmoji: function() {
      if (this.hasEmoticons) {
        this.callEmoji();
      }
    },
    callTooltip: function() {
      Vue.nextTick(function() {
        $('[rel="tooltip"]').tooltip()
      })
    },
    checkLenEmoji: function(event) {
      var nChar = emojioneAreaIstance.getText().length
      if (nChar >= this.getMaxAllowSize()) {
        this.maxLenMessage();
      } else {
        $('[rel="tooltipChar"]').tooltip("hide")
      }

    },
    callEmoji: function() {
      var that = this;
      Vue.nextTick(function() {

        var optionsEmoji = {
          pickerPosition: "top",
          filtersPosition: "bottom",
          tones: false,
          autocomplete: false,
          inline: false,
          hidePickerOnBlur: false,
        }

        if (that.options.internal.isAnimationCompatibility) {
          optionsEmoji.filters = {
            objects: false, // disable objects filter
            symbols: false, // disable symbols filter
            flags: false // disable flags filter
          }
        };

        var elEmoji = $("#emojionearea").emojioneArea(optionsEmoji);
        emojioneAreaIstance = elEmoji[0].emojioneArea;
        emojioneAreaIstance.setFocus();


        // console.log(emojioneAreaIstance)
        emojioneAreaIstance.on("keyup", function(btn, event) {
          that.hideTooltip();
          that.checkComposing();
          that.checkLenEmoji(event);
          event.preventDefault();
        });
        document.addEventListener("keydown", function(event) {
          if (event.shiftKey && event.which == 13) {
            console.log('ctrl-enter')
            var msg = emojioneAreaIstance.getText();
            emojioneAreaIstance.setText(+'\n');
            event.preventDefault();
          }
           else if (event.which == 13 && !event.shiftKey) {
            if (!that.disabled) {
              console.log('enter')
              var msg = emojioneAreaIstance.getText();
                that.setMsgFromEmoji(msg.trim());
            }
            event.preventDefault();
          }
        });
        
        setTimeout(function(){ 
          new PerfectScrollbar(".emojionearea-editor");
         }, 1000);

      });

      

    },

    hideTooltip: function() {
      $('[rel="tooltip"]').tooltip("hide");
    },
    showActionTooltipDoc: function() {
      //Visto che vado a mostrare il tooltip mi assicuro che il flag della graffetta sia a true
      this.options.configuration.allowShareDoc = true;
      Vue.nextTick(function() {
        $('#docSharing').tooltip("show");
        setTimeout(function() {
          $('#docSharing').tooltip("hide");
        }, 2500);
      })
    },

    contentShow: function(val) {
      this.isActive = val;
    },
    checkCompatibiltyPlaceHolderForEmoticons: function() {
      if (this.options.internal.isEdge || !this.options.internal.isAnimationCompatibility) {
        this.text.toolTipOnlyIe = this.labellang.chatuserinputPlaceholder;
        return '';
      } else {
        return this.labellang.chatuserinputPlaceholder;
      }

    },
    checkChannel: function() {
      if (this.options.configuration.channel != 'chat') {
        this.disabled = true;
      }

    },
    getMaxAllowSize: function() {
      return this.options.internal.maxAllowedMessageSize;
    },
    getSharingActive: function() {
      if (this.options.internal.isConvy == true || this.options.isVirtualAgent == true){
				return false;
			}else{
				return true;
      }
      
    },
    getSharingDocDisabled: function() {
      return this.options.configuration.disableShareDoc;
    },
    getEmailReservationDisabled: function() {
      return this.options.configuration.disableEmailReservation;
    },
    openShareDoc: function() {
      bus.$emit("onShareDoc", true);
      this.hideTooltip();
    },
    checkValidInput: function(e) {
      //		console.log("checkValidInput");
      var isEnter = (e.which || e.keyCode) == 13 ? true : false;
      if (this.newMessage.length >= this.getMaxAllowSize() && !isEnter) {
        this.maxLenMessage();
      } else {
        this.checkComposing();
      }
    },
    checkComposing: function() {
      var that = this;
      if (!this.isComposing.customer) {
        this.isComposing.customer = true;
        this.options.internal.bridge.sendComposing(true);
      }

      clearTimeout(this.timerIsComposing);
      this.timerIsComposing = setTimeout(function() {
        this.isComposing.customer = false;
        this.options.internal.bridge.sendComposing(false);
      }.bind(this), 2000);
    },
    addMessage: function() {
      var that = this;
      var timeout = null;
      clearTimeout(timeout);
      timeout = setTimeout(function(){
        if (that.newMessage.length != 0) {
          var msg = that.newMessage;
          bus.$emit("newMessage", msg);
          that.newMessage = '';
        }
        that.hideTooltip();
      },500)
        
    },
    setMsgFromEmoji: function(msg) {
      if (msg.length != 0) {
        if (msg.length >= this.getMaxAllowSize()) {
          this.maxLenMessage();
        } else {
              var timeout = null;
              clearTimeout(timeout);
              timeout = setTimeout(function(){
                bus.$emit("newMessage", msg);
              },1000)
              emojioneAreaIstance.setText('');
              emojioneAreaIstance.hidePicker();
        }
      }

    },
    addMessageWithEmoji: function() {
      var that = this;
      var msg = emojioneAreaIstance.getText();
      //	console.log(msg)
      // setTimeout(function() {
      // 		that.setMsgFromEmoji(msg);
      // }, 200);

      that.setMsgFromEmoji(msg);


    },
    maxLenMessage: function() {
      Vue.nextTick(function() {
        $('[rel="tooltipChar"]').tooltip("show")
      })

    },
    openReserveEmail: function() {
      bus.$emit("onReserveEmail", true);
        this.disable(true);
        this.hideTooltip();
    },
    getEmailActive: function() {
      return this.options.configuration.allowEmailReservation;
    },
    disableEmojiEditor: function() {
      $(".emojionearea-editor").attr("placeholder", this.labellang.sessionPaused);
      $(".emojionearea-editor").prop('disabled', true)
      $(".emojionearea").prop('disabled', true)
      $(".emojionearea-editor").prop('contenteditable', false)
      $(".emojionearea-button").hide();
      if (this.options.internal.endChat) {
        $(".emojionearea-editor").attr("placeholder", this.labellang.bye);
      }

      if(this.isTextInputDisable){
        $(".emojionearea-editor").attr("placeholder", this.labellang.text_input_disable);
      }
      

    },
    enableEmojiEditor: function() {
      $(".emojionearea-editor").attr("placeholder", this.labellang.chatuserinputPlaceholder);
      $(".emojionearea-editor").prop('disabled', false)
      $(".emojionearea").prop('disabled', false)
      $(".emojionearea-editor").prop('contenteditable', true)
      $(".emojionearea-button").show();

    },
    setInputDisable:function(val){
      this.isTextInputDisable = val;
      $('#chat-footer').show();
    },
    setInputClean:function(){
      if (this.hasEmoticons) {
        if (emojioneAreaIstance && emojioneAreaIstance.setText)
          emojioneAreaIstance.setText('');
      }else {
        this.newMessage = '';
      }

    },
    disable: function(boolean) {
      var that = this;
      this.disabled = boolean;
      //		console.log(this.disabled)

      if (boolean == true) {
        
        this.newMessage = this.labellang.sessionPaused
        if(this.isTextInputDisable){
          this.newMessage = this.labellang.text_input_disable
        }
        if (this.hasEmoticons) {
          setTimeout(function() { that.disableEmojiEditor(); }, 1000);
        }

        if (this.options.internal.endChat) {
          this.newMessage = this.labellang.bye;
          $('#chat-footer').hide();
        }

      } else {
        this.newMessage = '';
        if (this.hasEmoticons) {
          setTimeout(function() {
            that.enableEmojiEditor();
            var input = document.getElementsByClassName("emojionearea-editor");//document.getElementsByClassName("input-msg");
            if (input && input.length>0) {
              input[0].focus();
            }
          }, 1000);
          $('#chat-footer').show();


        } else {
          var input = document.getElementsByClassName("input-msg");
          if (input && input.length>0) {
            input[0].focus();
          }
        }
      }
    }
  },
})
